export class HisUploadFile {

    // hisResource data
    /**if the file was upload to an s3 storage, this contains the external identifier, otherise string representation of the HisResource byte array; should never contain the dataUrl header; */
    base64: string;
    name: string;
    lastModified: string;
    contentType: string;

    // remainig data of uploadFieldResource
    id: number;
    uuid: string;
    configKey: string;
    comment: string;
    expireDate: Date;
    documentMetadataCategoryId: number;
    documentMetadataCategoryHiskeyId: number;
    createdAt: Date;
    downloadUrl: string='';
    sortorder: number;
    supportsStreaming: boolean;
}

export class FilesChangedEvent {
    constructor(
        public readonly oldFiles: HisUploadFile[],
        public readonly newFiles: HisUploadFile[]
    ) { }
}

export class FilesMutatedEvent {
    constructor(
        public readonly file: HisUploadFile,
        public readonly newFiles: HisUploadFile[]
    ) { }
}
